import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { Field, FieldProps } from "formik";
import { ComponentProps } from "react";

type DateInputProps = Omit<
  ComponentProps<typeof DateInput>,
  "value" | "onChange" | "name" | "onBlur"
>;

type DateFieldProps = {
  name: string;
  dateProps?: DateInputProps;
} & DateInputProps;

export const DateField = ({ name, dateProps, ...rest }: DateFieldProps) => {
  const resolvedProps = { ...dateProps, ...rest };

  return (
    <Field name={name}>
      {({ field }: FieldProps) => (
        <DateInput
          {...field}
          {...resolvedProps}
          portalId={resolvedProps.portalId || field.name}
          placeholder={resolvedProps.placeholder || "DD-MMM-YYYY"}
        />
      )}
    </Field>
  );
};
